import CritiqueReviewLoader from './CritiqueReviewLoader'
export default CritiqueReviewLoader
